import script from "./CustomButtonBack.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomButtonBack.vue?vue&type=script&setup=true&lang=ts"

import "./CustomButtonBack.vue?vue&type=style&index=0&id=7add4bb6&lang=less"

const __exports__ = script;

export default __exports__